import React from 'react';
import { Components } from './styled';
import ProjectSimpleModal from '../../../../../components/ProjectSimpleModal';
import { parseDateToStringWithFormat } from '../../../../../utils/dateFormat';
import { format } from '../../../../../utils/dateFormat/types';

const ModalBody = ({ modalState, onClose }: { modalState?: any; onClose: () => void }) => {
  const activeSubscriptionData = modalState?.data;
  const hasAnySubscription = !!activeSubscriptionData?.subscriptionId;
  const allSubscriptions =
    modalState?.subscriptions && Object.keys(modalState?.subscriptions)?.length
      ? Object.entries(modalState?.subscriptions)?.map(([key, value]) => ({
          id: key,
          ...(value as any),
        }))
      : [];
  const firstSeen = modalState?.firstSeen
    ? parseDateToStringWithFormat(modalState?.firstSeen, format.weekDayMonthDayYearTime)
    : 'invalid';
  return (
    <Components.ModalContainer>
      <Components.ModalBodyContainer>
        <Components.ModalTitle>Subscription info</Components.ModalTitle>
        <Components.ModalContentWrapper>
          <Components.FieldText>First seen: {firstSeen}</Components.FieldText>
          <Components.FieldLabel>Active Subscription</Components.FieldLabel>
          {hasAnySubscription ? (
            <Components.FieldWrapper>
              <Components.FieldText>Subscription ID: {activeSubscriptionData?.subscriptionId}</Components.FieldText>
              <Components.FieldText>
                Expiration date:{' '}
                {activeSubscriptionData?.subscriptionExpirationDate
                  ? parseDateToStringWithFormat(
                      activeSubscriptionData?.subscriptionExpirationDate,
                      format.weekDayMonthDayYearTime,
                    )
                  : 'invalid'}
              </Components.FieldText>
              <Components.FieldText>Platform: {activeSubscriptionData?.subscriptionPlatform}</Components.FieldText>
              <Components.FieldText>
                Transaction ID: {activeSubscriptionData?.subscriptionTransaction}
              </Components.FieldText>
            </Components.FieldWrapper>
          ) : (
            <Components.FieldText>None</Components.FieldText>
          )}
          <Components.FieldLabel>All Subscriptions</Components.FieldLabel>
          {allSubscriptions?.length ? (
            allSubscriptions?.map((t, key) => (
              <Components.FieldWrapper key={key}>
                <Components.FieldText>Subscription ID: {t?.id}</Components.FieldText>
                <Components.FieldText>
                  Expiration date:{' '}
                  {t?.expires_date
                    ? parseDateToStringWithFormat(t?.expires_date, format.weekDayMonthDayYearTime)
                    : 'invalid'}
                </Components.FieldText>
                <Components.FieldText>
                  Purchase date:{' '}
                  {t?.original_purchase_date
                    ? parseDateToStringWithFormat(t?.original_purchase_date, format.weekDayMonthDayYearTime)
                    : 'invalid'}
                </Components.FieldText>
                <Components.FieldText>Period type (normal / trial): {t?.period_type}</Components.FieldText>
                <Components.FieldText>Store: {t?.store}</Components.FieldText>
              </Components.FieldWrapper>
            ))
          ) : (
            <Components.FieldText>None</Components.FieldText>
          )}
        </Components.ModalContentWrapper>
      </Components.ModalBodyContainer>
      <Components.ModalButtonsContainer>
        <Components.ModalPrimaryButton onClick={onClose}>Close</Components.ModalPrimaryButton>
      </Components.ModalButtonsContainer>
    </Components.ModalContainer>
  );
};

const SubscriptionInfoModal = ({
  isModalOpen,
  modalState,
  onModalClose,
}: {
  isModalOpen: boolean;
  modalState?: any;
  onModalClose: () => void;
}) => {
  return (
    <ProjectSimpleModal
      bodyChildren={<ModalBody modalState={modalState} onClose={onModalClose} />}
      isModalOpen={isModalOpen}
    />
  );
};

export default SubscriptionInfoModal;
